import { render, staticRenderFns } from "./NewGarage.vue?vue&type=template&id=26eddf44&scoped=true&"
import script from "./NewGarage.vue?vue&type=script&lang=js&"
export * from "./NewGarage.vue?vue&type=script&lang=js&"
import style0 from "./NewGarage.vue?vue&type=style&index=0&id=26eddf44&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26eddf44",
  null
  
)

export default component.exports